var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "label",
      {
        staticClass: "margin-0",
        staticStyle: {
          "--label-font-size": "var(--font-size-sm)",
          "--link-color": "var(--fa-navy)",
          "--label-font-weight": "normal",
          display: "flex",
          gap: "var(--spacing-3xs)",
        },
        attrs: { for: "accept-policies" },
      },
      [
        _c("input", {
          attrs: {
            id: "accept-policies",
            name: "accept-policies",
            type: "checkbox",
            required: "",
          },
          domProps: { checked: _vm.value, value: _vm.acceptPoliciesValue },
          on: { change: (event) => _vm.$emit("input", event.target.checked) },
        }),
        _vm._v(" "),
        _vm.isGdprUser
          ? _c(
              "span",
              [
                _vm._v("\n      I agree to the\n      "),
                _c(
                  "site-link",
                  { staticClass: "strong", attrs: { to: { name: "tos" } } },
                  [_vm._v("\n        Terms of Service")]
                ),
                _vm._v(",\n      "),
                _c(
                  "site-link",
                  { staticClass: "strong", attrs: { to: { name: "privacy" } } },
                  [_vm._v("\n        Privacy Policy")]
                ),
                _vm._v("\n      and\n      "),
                _c(
                  "site-link",
                  { staticClass: "strong", attrs: { to: { name: "dpa" } } },
                  [_vm._v("\n        Data Processing Agreement")]
                ),
                _vm._v(".\n    "),
              ],
              1
            )
          : _c(
              "span",
              [
                _vm._v("\n      I agree to the\n      "),
                _c(
                  "site-link",
                  { staticClass: "strong", attrs: { to: { name: "tos" } } },
                  [_vm._v("\n        Terms of Service")]
                ),
                _vm._v("\n      and\n      "),
                _c(
                  "site-link",
                  { staticClass: "strong", attrs: { to: { name: "privacy" } } },
                  [_vm._v("Privacy Policy")]
                ),
                _vm._v(".\n    "),
              ],
              1
            ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }